import { MouseEvent } from 'react';
import { matchPath, useHistory } from 'react-router-dom';

import { getParameterizedLink } from '@/utils/getLinkWithSubscriptionId.utils';
import { SearchBreadcrumbPageNames } from './GridFilteredBySearch.breadcrumb';

interface IGridFilteredBySavedSearchBreadcrumb {
  defaultText: string;
  breadcrumbPage: SearchBreadcrumbPageNames;
  path: string;
}


export default function GridFilteredBySavedSearch({
  defaultText,
  breadcrumbPage,
  path
}: IGridFilteredBySavedSearchBreadcrumb) {
  const history = useHistory();
  const filterName = new URL(window.location.href).searchParams.get('filterName') ?? '';
  const filterKey = new URL(window.location.href).searchParams.get('filterKey') ?? '';
  const search = new URL(window.location.href).searchParams.get('search') ?? ''; 
  const onClick = (event: MouseEvent) => {
    event.preventDefault();
    const pathName = new URL(window.location.href).pathname;

    const isContractsFilteredBySavedFilter = matchPath(pathName, {
      path: path,
      exact: true,
    });

    if (isContractsFilteredBySavedFilter) {
      window.location.reload();
    }
    else {
      let link = getParameterizedLink(`${path}?filterKey=${filterKey}&filterName=${filterName}`);
      if(search)
      {
        link = getParameterizedLink(`${path}?filterKey=${filterKey}&filterName=${filterName}&search=${search}`);
      }
      history.push(link);
    }
  };

  if (!filterName) {
    return <>{defaultText}</>;
  }

  return (
    <a
      onClick={onClick}
      href={window.location.href}
    >
      {`${breadcrumbPage} filtered by saved search: ${filterName}`}
    </a>
  );
}
